import React from 'react';
import { Typography } from 'antd';
import LinkPlaid from '../../../../components/buttons/linkplaid';

const { Link } = Typography;

function InstitutionReconnectItem(props) {
    return (
        <>
            {(props.source === "PL") ? (
                <LinkPlaid
                    buttonText={<span style={{ color: "#1890ff", cursor: "pointer" }}>{props.title || props.institutionName}</span>}
                    type="reconnect"
                    plaidAccountId={props.sourceAccountId}
                    isAssigned={false}
                    isSourceId={true}
                />
            ) : (props.source === "FI" && props.reconnectURL) ? (
                <Link href={props.reconnectURL} target="_blank">
                    {props.title || props.institutionName}
                </Link>
            ) : (
                <Link disabled>
                    {props.title || props.institutionName}
                </Link>
            )}
        </>
    )
}

export default InstitutionReconnectItem